import React from 'react'
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import {assignIn, get} from 'lodash'
import { render } from 'react-dom'
import App from './App'
import getQueryVariable from './tools/getQueryVariable'
import popup from './views/Popup/popup'
import { refreshUser, fetchUserSubscription, onUser } from './redux/user/helpers'
import { capitalize } from './tools/utils'
import './assets/css/fix.css'
import './assets/css/base.scss'
import pageStore from './redux/page/store'
import userStore from './redux/user/store'
import { fetchPage } from './redux/page/actions'
import { initCleverTap, addUserProfile } from './tools/analytics/cleverTap'
import { requestUserPermission, anonymousUserPushNotification } from './tools/webWorker'
import { pushToDatalayer } from "~/tools/analytics/gtmDatalayer";
import './adobePass/adobePrimeCallbacks.js'
import initializeAccessEnabler from './adobePass/loadAccessEnabler'
import {initializeRawInflate} from'./verimatrix/callbacks'
import { getProp } from './tools/custom-lodash'
import loadIVSLibrary from './ivs/loadIvsLib'


var location = window.location
var route = location.pathname
var requestHost = location.hostname
var domainNames = window.settings.domainNames
if(!domainNames.includes(requestHost)) {
	var originPathElement = document.getElementById('origin-path');
	var originPath = null;
	if(originPathElement) {
		originPath = originPathElement.getAttribute('data-seo');
	}
	if(originPath && route !== originPath) {
		route = originPath
	}
}

if (route.length > 1) route = route.replace(/\/$/, '')
var page = pageStore.getState()
if (!(page.data && page.data.route === route) && !page.fetchingPage)
	pageStore.dispatch(fetchPage(route))

initCleverTap()

loadIVSLibrary();
var aisresponse = getQueryVariable('aisresponse')
if(aisresponse){
	initializeRawInflate()
}
if(get(window.settings, 'serviceType') === 'TVE'){
	initializeAccessEnabler()
}

onUser((user) => {
	if (user && user.email) {
		pushToDatalayer('user_email', user.email);
	}
})

var setUserStatus = function(tokenExpired = false) {
	const sessionFlag = sessionStorage.getItem("sessionFlag") || false;
	if (!sessionFlag || (sessionFlag && sessionFlag === "false") || tokenExpired) {
		refreshUser().then(() => {
			var userInfo = userStore.getState().user || {}
			userInfo.userId && userInfo.isSubscribed && fetchUserSubscription();
		});
	}
	sessionStorage.setItem('sessionFlag', true);
}
function clevertapInit() {
	var userInfo = userStore.getState().user || {}
	if (userInfo.userId) {
		var userProfileData = {
			'Name': userInfo.name,
			'Email': userInfo.email,
			'Identity': userInfo.userId,
			'Phone': userInfo && userInfo.phone ? ((typeof userInfo.phone === 'string' && (userInfo.phone.charAt(0) !== '+')) ? JSON.parse(userInfo.phone) : userInfo.phone) : "", 
			'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
			'registration_method': userInfo.provider,
			'registration_platform': userInfo.registerdVia && capitalize(userInfo.registerdVia.split('_')[0]),
			'registration_date': userInfo.registeredOn,
			'registration_country': userInfo.country,
			'MSG-whatsapp': userInfo && userInfo.whatsappConsent ? userInfo.whatsappConsent : false, 
		}
		const { subscriptionInfo = null, subscriptionPlanInfo = null } = userInfo.subscription || {};
		if (userInfo.isSubscribed && userInfo.subscription && subscriptionInfo) {
			assignIn(userInfo, userStore.getState().user);
			assignIn(userProfileData, {
				'paymentMode': subscriptionInfo.cardType || null,
				'paymentHandler': subscriptionInfo.paymentHandler || null,
				'subscriptionStartDate': subscriptionInfo.subscriptionStartDate || null,
				'subscriptionEndDate': subscriptionInfo.subscriptionEndDate || null,
				'transactionId': subscriptionInfo.vlTransactionId || null,
				'discountAmount': subscriptionInfo.planAmount || null,
				'paymentPlan': subscriptionPlanInfo ? subscriptionPlanInfo.name : null,
				'freeTrial': subscriptionInfo.freeTrial ? 'Yes' : 'No',
				'country': subscriptionInfo.countryCode || null,
				'currency': subscriptionInfo.currencyCode || null,
				'amount': (subscriptionPlanInfo && subscriptionPlanInfo.planDetails[0]) ? subscriptionPlanInfo.planDetails[0].strikeThroughPrice : null,
			})
			addUserProfile('Site', userProfileData)
		} else {
			addUserProfile('Site', userProfileData)
		}
		if (getProp(window, "settings.notifications.enableWebPushNotification", null))	requestUserPermission();
	} else {
		addUserProfile('Site', { 'User Status': 'Anonymous' });
		getProp(window, "settings.notifications.enableAnonymousUserWebPushNotification", null) && anonymousUserPushNotification();
	}
}
if (window.settings.serviceType === 'SVOD') {
	setUserStatus();
	clevertapInit();
 	//checking on the page load
	const duration = (window && window.localStorage.token && JSON.parse(window.localStorage.token).duration) || 1800000;	//Time Interval fetched from token expiration | Validity of auth token
	setInterval(() => setUserStatus(true), duration); //refreshing the user after a fixed time interval | Default is 1800000ms or 30mins
}

var plans = getQueryVariable('forwardParams')
var app = getQueryVariable('app')
const params = new URLSearchParams(window.location.search)
const offerCode = params.get('offer')
if (offerCode) {
	window.sessionStorage.setItem('offer', offerCode)
}
if (app) {
	window.sessionStorage.setItem('isApp', true)
}
if (plans) {
	const plans = params.get('forwardParams')
	window.sessionStorage.setItem('plans', plans.split('=')[1])
}
var popupName = getQueryVariable('popup')
if (popupName && popup[popupName]){
	if(get(window.settings, 'isMonetizationModelEnabled') && popupName === 'createSubscription'){
		popup['createSubscription02']()
	}else{
		popup[popupName]()
	}
}

render(<App />, document.getElementById('root'))